<div class="col-2">
  <p-floatlabel variant="on">
    <p-select
      [options]="sites"
      [(ngModel)]="selectedSite"
      (onChange)="getCatalog()"
      data-testid="site"
      filterPlaceholder="Search Unit"
      class="w-full required"
      appendTo="body">
    </p-select>
    <label for="site">Site</label>
  </p-floatlabel>
</div>

<div class="grid">
  <div class="col-7">
    <button pButton label="Add Insect Only Item" class="p-button" (click)="openInsectModal()"></button>
  </div>
</div>

<p-dialog
  *ngIf="showInsectModal"
  [modal]="true"
  [showHeader]="false"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [(visible)]="showInsectModal"
  appendTo="body"
  styleClass="order-item-dialog"
  [style]="{ 'width': '60rem' }">
  <app-poc-order-insect
    [editingInstance]="editingInstance"
    [modalTitle]="modalTitle"
    [projects]="projects"
    [projectTooltipText]="projectTooltipText"
    [selectedSite]="selectedSite"
    (dialogCancelEvent)="onDialogCancelInsect()">
  </app-poc-order-insect>
</p-dialog>

<!-- [orderId]="orderInfo.id"
    [catalogId]="orderInfo.catalogId"
    [locationId]="orderInfo.deliveryLocationId"
    [profile]="pageVars.profile"
    [projects]="projects"
    [catalogInformation]="catalogInformation"
    [editingOrderItemDetails]="selectedOrderItem"
    [editing]="editing"
    [editingInstance]="editingInstance"
    [editingMode]="editingMode"
    [canApprove]="this.permissions.insectaryApproveOrders"
    [selectedOrderInstance]="selectedEditInstance"
    [status]="editingStatusInstances"
    [modalTitle]="modalTitle"
    [projectTooltipText]="projectTooltipText"
    (dialogCloseEvent)="onDialogCloseInsect()"
    (dialogCancelEvent)="onDialogCancelInsect()" -->
